import React from "react";

// import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
// import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";

export default function Features() {
  return (
    <CardContent>
      <Typography variant="body1" color="primary" component="h2">
        Apply Filters
      </Typography>
      <Typography variant="body2" component="p">
        <b> BharatDocumentScanner </b>
        comes with filters to make the documents B/W or enhance the colors for
        better visibility.
        <br />
        <br />
        <br />
      </Typography>
      <Typography variant="body1" color="primary" component="h2">
        Lightening Speed
      </Typography>
      <Typography variant="body2" component="p">
        <b> BharatDocumentScanner </b>
        is extremely fast as it does not require any internet connection hence
        all the documents get scanned instantly!
        <br />
        <br />
        <br />
      </Typography>
      <Typography variant="body1" color="primary" component="h2">
        Auto Edge Cropping
      </Typography>
      <Typography variant="body2" component="p">
        <b> BharatDocumentScanner </b>
        automatically detects the edges of the document and crops it for you.
        You can customize and crop specific regions as well.
      </Typography>
    </CardContent>
  );
}
